import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import LandingPage from './LandingPage'
import MarketingRootRedirect from './MarketingRootRedirect'
import { publicLegalRouteElements } from '../public/PublicLegalRoutes'
import './marketing.css'

/**
 * Marketing Surface root — Phase SAAS-ENTRY-A1 §3. Deliberately its own
 * small `<BrowserRouter>`/`<Routes>` tree, separate from the SaaS App
 * Surface's (`App.tsx`) — no `AuthProvider`, no `saas/api` import, no
 * Tenant/Media/Editor code reachable from here at all (enforced by
 * `backend/tests/test_frontend_navigation_contract.py`). "登录" /
 * "免费开始使用" always link to the SaaS App Surface's own absolute URL
 * (`../config/surface.ts#getLoginUrl/getSignupUrl`), never an in-app
 * route — signup/login/workspace stay exactly where they already work
 * today (App Surface).
 *
 * VISTOERA_HOME_IS_CANVAS_V1 (VistoeraTASK-00264) — `/` itself is no
 * longer the Landing Page (see `MarketingRootRedirect.tsx`): the product
 * direction is "Canvas-first", so the Marketing Surface's root now hands
 * off to the App Surface immediately instead of gating it behind a
 * mandatory brochure page. The Landing Page component is fully preserved
 * (spec §十), just relocated to `/product` — still directly reachable,
 * still the target for any future Marketing IA expansion, never deleted.
 */
export default function MarketingApp() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MarketingRootRedirect />} />
        <Route path="/product" element={<LandingPage />} />
        {publicLegalRouteElements()}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}
